import styled from "styled-components";
import { AnchorHeading as OriginalAnchorHeading } from "@/components/layout/DocLayout/styled";

export const AnchorHeading = styled(OriginalAnchorHeading)`
  margin: 0;
  padding-top: 2rem;
  padding-bottom: 0.5rem;
  &:first-of-type {
    padding-top: 0;
  }
`;

export const RelationshipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  flex-wrap: wrap;

  > * {
    flex: 1;
  }
  ${(props) => props.theme.media.medium} {
    flex-direction: row;
  }
`;
export const RelationshipBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 0.5rem;
`;

export const FrameworkFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

export const FrameworkField = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > span:last-child {
    font-size: 0.875rem;
    line-height: 1.35;
    font-weight: 300;
  }
`;
